export enum CustomFieldConditionEnum {
  IS_NOT_NULL = 'is-not-null',
  IS_NULL = 'is-null',
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'does-not-contain',
  BIGGER_THAN = 'bigger-than',
  LOWER_THAN = 'lower-than',
  EQUAL = 'equal',
  NOT_EQUAL = 'not-equal',
}
